<template>
  <b-card
    no-body
    class="px-5 pt-5 rounded-xl animated mb-3 d-flex flex-row align-items-center"
    :bg-variant="`${data.variant}`"
    style="min-width: 155px"
  >
    <div class="w-100">
      <slot name="header"></slot>
      <b-row>
        <!-- first value -->
        <b-col :cols="data.cols || 'auto'" :class="`mb-5 pr-4`">
          <div class="d-flex align-items-center">
            <i v-if="data.icon" :class="`${data.icon} font-size-h1 mr-4`"></i>
            <div>
              <p
                :class="`${
                  data.titleClass || 'font-size-h6 font-weight-bold'
                } mb-0`"
              >
                {{ data.title }}
                <i
                  v-if="data.tooltip"
                  v-b-tooltip="data.tooltip"
                  class="ri-information-line"
                ></i>
              </p>
              <number
                v-if="
                  typeof data.value == 'number' ||
                  (!isNaN(data.value) && data.value.trim() !== '')
                "
                :class="`font-size-${
                  data.largeValue ? 'h2' : 'h3'
                } font-weight-bolder mb-0 ${data.valueClass || ''}`"
                tag="p"
                :from="0"
                :format="
                  ($v) =>
                    $options.filters.parse(
                      Math.floor($v),
                      data.transform || 'number'
                    )
                "
                :to="data.value"
                :duration="data.duration || 3"
                easing="Circ.easeInOut"
              />
              <p
                v-else
                :class="`font-size-${
                  data.largeValue ? 'h2' : 'h3'
                } font-weight-bolder mb-0 ${data.valueClass || ''}`"
              >
                {{ data.value }}
              </p>
              <p
                v-if="data.subValue"
                variant="primary"
                :class="`${data.subValueClass || null} mb-0`"
              >
                {{ data.subValue }}
              </p>
            </div>
          </div>
        </b-col>
        <!-- more values -->
        <template v-for="(moreV, moreVIndex) in moreValuesKey">
          <b-col
            :key="`more-values-col-${moreVIndex}`"
            :cols="data[moreV].cols || 'auto'"
            v-if="data[moreV] && data[moreV].title"
            class="pl-3 border-2 border-left mb-5 pr-4"
          >
            <div class="d-flex align-items-center">
              <i
                v-if="data[moreV].icon"
                :class="`
                    ${data[moreV].icon !== true ? data[moreV].icon : data.icon}
                    font-size-h1
                  `"
              ></i>
              <div class="ml-4">
                <p class="font-size-h6 font-weight-bold mb-0">
                  {{ data[moreV].title }}
                  <i
                    v-if="data[moreV].tooltip"
                    v-b-tooltip="data[moreV].tooltip"
                    class="ri-information-line"
                  ></i>
                </p>
                <number
                  v-if="
                    typeof data[moreV].value == 'number' ||
                    (!isNaN(data[moreV].value) &&
                      data[moreV].value.trim() !== '')
                  "
                  :class="`font-size-${
                    data[moreV].largeValue ? 'h2' : 'h3'
                  } font-weight-bolder mb-0 ${data[moreV].valueClass || ''}`"
                  tag="p"
                  :from="0"
                  :format="
                    ($v) =>
                      $options.filters.parse(
                        Math.floor($v),
                        data[moreV].transform || 'number'
                      )
                  "
                  :to="data[moreV].value"
                  :duration="data[moreV].duration || 3"
                  easing="Circ.easeInOut"
                />
                <p
                  v-else
                  :class="`font-size-${
                    data[moreV].largeValue
                      ? 'h2'
                      : data[moreV].smallValue
                      ? 'font-size-sm'
                      : 'h3'
                  } font-weight-bolder mb-0 ${data[moreV].valueClass || ''}`"
                >
                  {{ data[moreV].value }}
                </p>
                <p
                  v-if="data[moreV].subValue"
                  variant="primary"
                  :class="`${data[moreV].subValueClass || null} mb-0`"
                >
                  {{ data[moreV].subValue }}
                </p>
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "NurseryFeStatisticCard",

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      moreValuesKey: ["first", "second", "third", "fourth", "fifth"],
    };
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/base/component/statistic-card.vue